import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import mathHelper from '../../../Helpers/mathHelper';
import PlanningDetailMultiEditItem from '../../../Domain/PlanningDetailMultiEditItem';

const rateValidityChecker = (value, editedItem) => {
  if (!editedItem || !editedItem.ApplyTargetRates) return '';
  return mathHelper.Sum(value) === 100 ? '' : 'The rates must add up to 100%.';
};

const rateFieldsDisabled = (item) => !item.ApplyTargetRates;

export default class PlanningDetailMultiEditWindowDescription {
  static titleForCreate = 'Edit Multiple Fieldwork Periods';
  static titleForEdit = 'Edit Multiple Fieldwork Periods';
  static itemType = PlanningDetailMultiEditItem;
  static finishButtonLabel = 'Modify all selected';
  static messageOnSuccess = 'The selected PlanningDetail Items have been modified.';

  static serviceFunction = async (item) =>
    PlanningDetailsItemService.EditMultiplePlanningDetailItems(item.Ids, {
      numberOfPlannedAssignments: parseInt(item.NumberOfPlannedAssignments, 10),
      applyValue: item.ApplyTargetRates,
      targetAssignmentRate: item.TargetAssignmentRate,
      targetCompletionRate: item.TargetCompletionRate,
    });

  static pagesInGeneralEditWizzard = [
    {
      fields: [
        // Everything here writes ONE value to EVERY selected period, which is why there are no date
        // fields: on this page the selection is consecutive periods of a single country, so one start
        // and end date would collapse them all onto the same window. People went looking for dates
        // here all the same, so say where they actually are rather than leave the panel silent.
        {
          fieldName: 'Info',
          label: '',
          className: 'col-12',
          type: InputTypesEnum.InfoCallout,
          buildContent: (item) => {
            const selectedCount = (item.Ids ?? []).length;
            const periodWord = selectedCount === 1 ? 'period' : 'periods';
            return {
              paragraphs: [
                `The planned shop count and target rates you set here are written to **all ${selectedCount}** selected fieldwork ${periodWord}. Periods in status **'Cancelled'** and **'Closed'** are left alone.`,
                'Fieldwork **dates are not on this panel** — one start and end date cannot be right for several periods at once. To change them:',
                'for **one period**, use **Edit** on its own row; for the **same period across several countries**, use **Multi Edit** on the Planning Items page, which gives each period its own dates.',
              ],
            };
          },
        },
        {
          fieldName: 'NumberOfPlannedAssignments',
          label: 'Number of Planned Assignments',
          className: 'col-12',
          type: InputTypesEnum.Number,
          // The note above says which periods are written to, and says it precisely — the vaguer
          // "only the selected and editable items" that used to sit here only repeated it.
          validityChecker: (value) => {
            const parsed = Number(value);
            if (value === '' || isNaN(parsed) || !Number.isInteger(parsed) || parsed < 0) {
              return 'The value must be an integer greater than or equal to 0.';
            }
            return '';
          },
        },
        {
          fieldName: 'ApplyTargetRates',
          label: 'Apply Target Rates',
          className: 'col-6',
          type: InputTypesEnum.SingleCheckBox,
        },
        {
          fieldName: 'TargetAssignmentRate',
          label: 'Target Assignment Rate (%)',
          className: 'col-6',
          type: InputTypesEnum.TargetRate,
          disabled: rateFieldsDisabled,
          validityChecker: rateValidityChecker,
        },
        {
          fieldName: 'TargetCompletionRate',
          label: 'Target Completion Rate (%)',
          className: 'col-6',
          type: InputTypesEnum.TargetRate,
          disabled: rateFieldsDisabled,
          validityChecker: rateValidityChecker,
        },
      ],
    },
  ];
}
